/* eslint-disable array-callback-return */
import { useState,useContext,useEffect } from 'react';
import  {IColabortador} from'../../../interfaces/PerformanceEvaluation.interface'
import { AdminContext } from "../../../context/AdminContext/AdminContext";
import PerformanceEvaluationContext from "../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import { useQuery,useMutation } from "@apollo/client";
import {GET_COLLBORATORS_NOT_IN_PEREVAL,
        CREATE_ADD_COL_PER_EVAL,
        GET_PEFORMANCE_EVALUATION_COLLBORATORS } 
from "../../../Querys/performanceEvaluation/querys";
import {closeColAddPerEvalModal } from "../../../context/PerformanceEvaluationContext/Actions";
import {
    Dialog,
    DialogTitle,
    DialogContent      
 } from '@material-ui/core';
 import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Form } from "semantic-ui-react";
import CheckmarkSelect from '../Components/CheckmarkSelect';
import { LoadingAlert } from "../../../alerts/loadingAlerts";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import { ErrorAlert } from "../../../alerts/errorAlert";

const ModalAddColaboratorPerformanceEvaluation = () => {
  const { adminState } = useContext(AdminContext)  
  const {state, dispatch} = useContext(PerformanceEvaluationContext); 
  const id= state._id 
  const [arrayCollaborators, setArrayCollaborators] = useState<IColabortador[]>([])  
  const [value, setValue] = useState<IColabortador[]>([]);

  const { data,startPolling, stopPolling} = useQuery(GET_COLLBORATORS_NOT_IN_PEREVAL, {
    variables: { idPerEval:id , idCompany:adminState?.idEnterprise   },    
  });    

  const collaborators = data?.GET_COLLBORATORS_NOT_IN_PEREVAL;  

  const [createColEvalPer] = useMutation(CREATE_ADD_COL_PER_EVAL, {
    refetchQueries: [
        { query: GET_PEFORMANCE_EVALUATION_COLLBORATORS ,
          variables: { idPerEval:id, idCompany:adminState?.idEnterprise },
        },
        {
          query: GET_COLLBORATORS_NOT_IN_PEREVAL ,
          variables: { idPerEval:id, idCompany:adminState?.idEnterprise },
        }
    ],
    
  });  

useEffect(()=>{
    startPolling(50000);
    return () =>{
        stopPolling()
    }
},[startPolling,stopPolling])

useEffect(() => { 
  if(data?.GET_COLLBORATORS_NOT_IN_PEREVAL){    
       setArrayCollaborators(collaborators)
     }     
    }, [data?.GET_COLLBORATORS_NOT_IN_PEREVAL, arrayCollaborators, collaborators]);

const closeModalAddExterno=()=>{
   // formik.resetForm();        
   setValue([])
   closeColAddPerEvalModal(id.toString(), false, dispatch)    
   
}

const onSaveColaboradores= async()=>{
  if(value.length >0){
    const copyArray=[...value]
    let obj = {}
    const array: any = []
     copyArray.map((col:any)=>{
       obj = {idPerEval:parseInt(id), idUsuario: parseInt(col.id) }
      array.push(obj)
    })
    LoadingAlert({ title: "Guardando  ..." }); 
    await createColEvalPer({
      variables: {
        input:{ 
          newColaboradores: array
        },
      },
    });      
    closeColAddPerEvalModal(id.toString(), false, dispatch)       
    if(array.length ===1){
    return SuccessfulAlert({ text: "Se agregó al colaborador a la evaluación." });    
    }
    if(array.length >1){
      return SuccessfulAlert({ text: "Se agregaron a los colaboradores a la evaluación." });    
      }
  }else{
 return  ErrorAlert({ text: 'Es necesario seleccionar a un colaborador.' });          
  }  
}

return (
  <>    
  <Dialog 
        open={state.modalCollaboratorAddPerformanceEvaluation}
         aria-labelledby="form-dialog-title" 
         className="dialogPrestacion"         
         >
      <IconButton aria-label="close" 
        onClick={(()=> {closeModalAddExterno() } )}
        sx={{position: 'absolute', right: 8, top: 8,color: (theme) => theme.palette.grey[500], }}
         >
        <CloseIcon />
      </IconButton>     
     <DialogContent  >
     <Form 
        className="containerMdalPrestacion" 
       // onSubmit={formik.handleSubmit} 
        >  
      <DialogTitle  className="titleModalPerformanceEval" ><span className="txtTitleModalPerformanceEval">Agregar Colaborador</span></DialogTitle>
      <DialogContent className="oneComponentAgreeEval">
       <CheckmarkSelect
          items={arrayCollaborators}
          label="Colaboradores"
          placeholder="Colaboradores "
          selectAllLabel="Todos"
          noOptionsText="No options"
          limitTags={3}
          onChange={setValue}
        />
       
      </DialogContent>

        <DialogContent className="twoComponentBtns">
            <div className="containerButtons">
              <div className="containerCancelPreestacion">
                <button className="btnCancelPrestacion" type="button"
                  onClick={(() => {                
                    closeModalAddExterno();                
                  }
                  )}>
                  Cancelar
                </button>
              </div>
              <div className="containerAddPrestacion">
                <button className="btnAddPrestacion" 
                   onClick={onSaveColaboradores}
                >
                  <div className="infobtnAddRestriccion">                 
                    <div><span className="txtBtnAdd">Agregar</span> </div>
                  </div>
                </button>
              </div>
            </div>
        </DialogContent>   
        </Form>    
     </DialogContent>     
  </Dialog>        
  </>
)
}


export default ModalAddColaboratorPerformanceEvaluation